// extracted by mini-css-extract-plugin
module.exports =  {"button":"_2787e5dfdf--button--wvpRY","dark":"_2787e5dfdf--dark--HdtBl"};